export const featuresLinks = {
    features: () => '/features'
};
